import React from 'react';
import {Table} from 'react-bootstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

export var NodeTable = React.createClass({
    render: function(){
        let attrs, attrMap;
        [attrs, attrMap ]= nodeAttr(this.props.nodes);
        let data = prepData(this.props.nodes, attrs, attrMap);
        let headings = nodeHeadings(attrs);
        let columns = [];
        for (let i = 0; i < attrs.length; i++) {
            columns.push(<TableHeaderColumn dataField={attrs[i]} key={attrs[i]}
                                            dataSort={true} sortFunc={sortFuncs(attrs[i])} width={colSize(attrs[i])}>
                {headings[i]}
                </TableHeaderColumn>);
        }

        return (<BootstrapTable data={data} striped={true} hover={true} condensed={true}
                                keyField="id" height={this.props.height.toString()}>
        {columns}
      </BootstrapTable>);
    }
});

function nodeAttr(nodes) {
    // Get all the node attributes used on nodes other than x, y, id, and type
    let nodeAttr = ["id", "type"];
    let attrMap = new Map();  // Set up a map to take us from attribute to formating type.
    attrMap.set("id", "string");
    attrMap.set("type", "string");
    for (let i = 0; i < nodes.length; i++) {
        let node = nodes[i];
        for (let attr in node) {
            if (node.hasOwnProperty(attr)) {
                if (nodeAttr.indexOf(attr) === -1) { // not already in the attribute list
                    if (attr !== 'x' && attr !== 'y' && node[attr] !== "") {
                        nodeAttr.push(attr);
                        if (!attrMap.has(attr)) {
                            attrMap.set(attr, typeof node[attr]);
                        }
                    }
                }
            }
        }
    }
    return [nodeAttr, attrMap];
}

/*
 The headings for the node table computed from the node attributes.
 */
function nodeHeadings(nodeAttr) {
    var headings = [];
    headings.push("Name");
    headings.push("Type");
    for (var i = 2; i < nodeAttr.length; i++) {
        headings.push(capitalize(nodeAttr[i]));
    }
    return headings;
}

function capitalize(s) {
    return s && s[0].toUpperCase() + s.slice(1);
}

function prepData(nodes, attrs, attrMap) {
    let data = nodes.map(function (n) {
            let nodeData = {};
            for (let attr of attrs) {
                if (!n[attr]) {
                    nodeData[attr] = null;
                    continue;
                }
                switch (attrMap.get(attr)) {
                    case 'object':
                        nodeData[attr] = JSON.stringify(n[attr]);
                        break;
                    case 'number':
                    case 'string':
                    default:
                        nodeData[attr] = n[attr];
                }

            }
            return nodeData;
        }
    );
    return data;
}

function colSize(attr) {
    switch (attr) {
        case "id":
            return "50";
        case "type":
            return "50";
        case  "layer":
            return "60";
        case "ipv4":
            return "75";
        case "mac":
            return "115";
        default:
            return "80";
    }
}

function sortFuncs(attr) {
    switch (attr) {
        case "ipv4":
            return function (a, b, order) {
                if (order === 'asc') {
                    return ipStringToInt(a.ipv4) - ipStringToInt(b.ipv4);
                } else {
                    return ipStringToInt(b.ipv4) - ipStringToInt(a.ipv4);
                }
            }
        case "mac":
            return function (a, b, order) {
                if (order === 'asc') {
                    return macStringToNum(a.mac) - macStringToNum(b.mac);
                } else {
                    return macStringToNum(b.mac) - macStringToNum(a.mac);
                }
            }
        default:
            return null;
    }

}

function ipStringToInt(ipString) {
    if (!ipString || ipString === "") {
        return 0;
    }
    let numStrings = ipString.split(".");
    let ipInt = 0;
    macInt |= parseInt(numStrings[0]) << 24;
    macInt |= parseInt(numStrings[1]) << 16;
    macInt |= parseInt(numStrings[2]) << 8;
    macInt |= parseInt(numStrings[3]);
    return macInt;
}

function macStringToNum(macString) {
    if (!macString || macString === "") {
        return 0;
    }
    let numStrings = macString.split(":");
    let macNum = 0;
    for (let i = 0; i < numStrings.length; i++) {
        macNum += parseInt(numStrings[i], 16)*Math.pow(16, i);
    }
    return macNum;
}


// WEBPACK FOOTER //
// ./src/info/NodeTable.js